import React from 'react';

const GlobalDataContext = React.createContext({
  globalMenuItemCategories: [],
});

export default GlobalDataContext;
